import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button, Container, Input } from '@sainsburys-tech/fable'

import api from '../../../utils/api'
import Logger from '../../../utils/logger'
import LoadingOverlay from '../../LoadingOverlay'
import EmailConfirmationModal from '../../Email/EmailConfirmationModal'
import '../../../sass/components/forgotten-password.scss'

class ForgottenPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      btnDisabled: true,
      email: '',
      loading: false,
      isModalOpen: false,
      modalType: '',
      userNotRecognised: false
    }
  }

  componentDidMount() {
    const { setHeaderBack } = this.props

    setHeaderBack()
  }

  handleButtonClick = async () => {
    const { email } = this.state

    this.setState({ loading: true })

    await api.checkEmailVerified(email)
      .then((result) => {
        if (result.status === 200) {
          this.setState({ isModalOpen: true, modalType: 'emailConfirmed', userNotRecognised: false })
        } else {
          this.setState({ userNotRecognised: true, btnDisabled: true })
        }
      }).catch((error) => {
        Logger.logError(error)
      })
    this.setState({ loading: false })
  }

  handleUsernameChange = (value) => {
    const nextValue = value || ''
    this.setState({
      userNotRecognised: false,
      btnDisabled: nextValue === '',
      email: nextValue
    })
  }

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      email: '',
      btnDisabled: true
    })
  }

  showModal = (type) => {
    const { isModalOpen, email } = this.state
    const { history } = this.props
    let errorModal = false

    if (type === 'unauthorised') {
      errorModal = true
    }

    if (isModalOpen) {
      return (
        <EmailConfirmationModal isModalOpen={isModalOpen} history={history} errorModal={errorModal} email={email} type={type} closeModal={this.closeModal} />
      )
    }
    return null
  }

  render() {
    const {
      btnDisabled,
      loading,
      modalType,
      email,
      userNotRecognised
    } = this.state

    return (
      <Container as="div" className="dsib-forgot">
        {this.showModal(modalType)}

        <div className="dsib-forgot__wrap">
          <h2 className="dsib-forgot__title">Forgotten password</h2>

          <p className="dsib-forgot__text">
            If you've forgotten your password we can send you an email to reset it.
          </p>
          <p className="dsib-forgot__text dsib-forgot__text--spaced">
            Enter your user name and we'll send the email to the one you registered with.
          </p>

          <div className="dsib-forgot__form">
            <div className={`dsib-forgot__field ${userNotRecognised ? 'dsib-forgot__field--error' : ''}`}>
              <Input
                label="Username"
                value={email}
                onChange={value => this.handleUsernameChange(value)}
                inputProps={{
                  id: 'txtUsername',
                  name: 'txtUsername',
                  autoComplete: 'username'
                }}
              />
              {userNotRecognised && (
                <div className="dsib-forgot__error" role="alert">
                  Username not recognised
                </div>
              )}
            </div>

            <div className="dsib-forgot__button">
              <Button
                isFullWidth
                disabled={btnDisabled}
                onClick={() => this.handleButtonClick()}
                variant="primary"
              >
                Reset my password
              </Button>
            </div>
          </div>
        </div>

        {loading && <LoadingOverlay hasBackground />}
      </Container>
    )
  }
}

ForgottenPassword.propTypes = {
  setHeaderBack: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,

}

export default ForgottenPassword
